export const initSearchToggle = () => {
	const searchButton = document.querySelector('.search-toggle-button');
	const searchDropdown = document.querySelector('.search-dropdown');
	const searchInput = searchDropdown?.querySelector('.search-input');
	
	if (!searchButton || !searchDropdown) return;

	const openSearch = () => {
		searchDropdown.hidden = false;
		searchDropdown.setAttribute('aria-hidden', 'false');
		searchButton.setAttribute('aria-expanded', 'true');
		setTimeout(() => {
			searchInput?.focus();
		}, 50);
	};

	const closeSearch = () => {
		searchDropdown.hidden = true;
		searchDropdown.setAttribute('aria-hidden', 'true');
		searchButton.setAttribute('aria-expanded', 'false');
		if (searchInput) searchInput.value = '';
	};

	searchButton.addEventListener('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		const isOpen = searchButton.getAttribute('aria-expanded') === 'true';
		isOpen ? closeSearch() : openSearch();
	});

	document.addEventListener('click', (e) => {
		if (!searchDropdown.contains(e.target) && !searchButton.contains(e.target)) {
			closeSearch();
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && searchButton.getAttribute('aria-expanded') === 'true') {
			closeSearch();
			searchButton.focus();
		}
	});
};
